// extracted by mini-css-extract-plugin
module.exports = {"bfixHeader":"style_bfixHeader__yIaQE","wrapper":"style_wrapper__5Sf27","regionDropdown":"style_regionDropdown__ZGFFu","datePicker":"style_datePicker__dtGBD"};